const HTTP_STATUS_LABELS: Readonly<Record<number, string>> = {
  401: 'unauthorized',
  403: 'forbidden',
  404: 'not-found',
  409: 'conflict',
  422: 'unprocessable',
  429: 'rate-limited',
  500: 'server-error',
  502: 'bad-gateway',
  503: 'service-unavailable',
  504: 'gateway-timeout',
};

const CLOUDFLARE_ORIGIN_STATUSES = new Set([520, 521, 522, 523, 524, 525, 526, 527, 530]);

export function classifyHttpStatus(status: number): string {
  if (CLOUDFLARE_ORIGIN_STATUSES.has(status)) {
    return 'origin-unreachable';
  }
  const label = HTTP_STATUS_LABELS[status];
  if (label) {
    return label;
  }
  if (status >= 500) {
    return 'server-error';
  }
  if (status >= 400) {
    return 'client-error';
  }
  return `http-${status}`;
}
